<template lang="pug" functional>
  .card-skeleton
    .card-item(v-for="i in props.count" :key="i")
      v-card
        .card-top
          .card-title
          .card-icon
        .card-content
          .card-wrapper(v-for="j in 3" :key="`${i}-${j}`")
            .card-text
</template>

<script>
export default {
  name: 'FarmCardItemRowSkeleton',

  props: {
    count: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/abstracts/_mixins.scss';
@import '@/sass/abstracts/_variables.scss';

.card-skeleton {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;

  &:not(:last-child) {
    margin-bottom: 2rem;
  }

  .card-top {
    padding: 1.5rem 1.5rem 1.5rem 2.5rem;
  }

  .card-content {
    @include mobile {
      display: none;
    }
  }

  .card-title {
    height: 2.2rem;
    width: 40%;
    border-radius: .8rem;
    @include skeleton;
  }

  .card-text {
    height: 1.8rem;
    width: 80%;
    border-radius: .8rem;
    @include skeleton;
  }

  .card-icon {
    margin-left: auto;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    @include skeleton;
  }
}
</style>
